import { render, staticRenderFns } from "./GenericPage.vue?vue&type=template&id=6eab83a3&scoped=true"
import script from "./GenericPage.vue?vue&type=script&lang=js"
export * from "./GenericPage.vue?vue&type=script&lang=js"
import style0 from "./GenericPage.vue?vue&type=style&index=0&id=6eab83a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eab83a3",
  null
  
)

export default component.exports